/**
 * Intro
 */
import $ from 'jquery';
import TweenMax from 'gsap/TweenMax';
import AbsSection from './AbsSection';
// import Config from '../module/Config';
import {
  // isMobileEnv,
  setCookie
} from '../util/util';
// import {
//     Modal
// } from '../vendor/ModalPopupRWD';

export default class Intro extends AbsSection {
  constructor(_containerID, _scrollMagicCon) {
    super(_containerID, _scrollMagicCon);

    const _ = this;

    _.$body = $('body');
    _.$sectionIntro = $(_containerID);

    _._$title = $('.header .title', _.$wrap);
    _._$logo = $('.logo', _._$wrap);
    _._$subcopy = $('.subcopy', _._$wrap);
    _._$infoBox = $('.el-info-box', _._$wrap);
    _._$infoWrap = $('.info-wrap p', _._$wrap);
    _._$joinBtn = $('.btn-join', _._$wrap);

    _.init();
  }

  init() {
    const _ = this;

    _.setHomeBtn();
    _.setHeight();
  }

  setHomeBtn() {
    // redirect cookie
    const homeBtn = $('.go-home, .logo');
    homeBtn.on('click', evt => {
      evt.preventDefault();
      setCookie('LineageM_WEB_VISIT_0531', false, 1);
      location.href = homeBtn.attr('href');
    });
  }

  setHeight(evt = null) {
    this.$sectionIntro.css('height', $(window).height());
  }

  animationIn() {
    console.log('Intro in');

    const _ = this;

    TweenMax.killTweensOf(_._$title);
    TweenMax.killTweensOf(_._$logo);
    TweenMax.killTweensOf(_._$subcopy);
    TweenMax.killTweensOf(_._$infoBox);
    TweenMax.killTweensOf(_._$infoWrap);
    TweenMax.killTweensOf(_._$joinBtn);

    TweenMax.fromTo(
      _._$title,
      0.8, {
        autoAlpha: 0,
        y: 10
      }, {
        scale: 1,
        autoAlpha: 1,
        y: 0,
        ease: Cubic.easeInOut
      }
    );

    TweenMax.fromTo(
      _._$logo,
      0.8, {
        autoAlpha: 0,
        y: 10
      }, {
        delay: 0.2,
        scale: 1,
        autoAlpha: 1,
        y: 0,
        ease: Cubic.easeInOut
      }
    );

    TweenMax.fromTo(
      _._$subcopy,
      0.8, {
        autoAlpha: 0,
        y: 10
      }, {
        delay: 0.4,
        scale: 1,
        autoAlpha: 1,
        y: 0,
        ease: Cubic.easeInOut
      }
    );

    TweenMax.fromTo(
      _._$infoBox,
      0.8, {
        autoAlpha: 0
      }, {
        delay: 0.3,
        autoAlpha: 1,
        ease: Cubic.easeInOut
      }
    );

    TweenMax.fromTo(
      _._$infoWrap,
      0.8, {
        autoAlpha: 0,
        y: 10
      }, {
        delay: 0.6,
        scale: 1,
        autoAlpha: 1,
        y: 0,
        ease: Cubic.easeInOut
      }
    );

    TweenMax.fromTo(
      _._$joinBtn,
      0.8, {
        autoAlpha: 0,
        y: 10
      }, {
        delay: 0.6,
        scale: 1,
        autoAlpha: 1,
        y: 0,
        ease: Cubic.easeInOut
      }
    );
  }

  animationOut() {
    console.log('Intro out');
  }

  resize(evt) {
    // override
    const _ = this;

    _.setHeight(evt);
  }
}